module.exports = __webpack_public_path__ + "static/media/correctivo_verde.428777b5.svg";